import React, { useMemo, useState } from 'react';
import {API} from 'aws-amplify';
import {startOver} from '../coresim/reducers/decisions';
import {getTickAction} from '../coresim/state';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Button, Dialog} from '@material-ui/core';
import {getPreload} from '../coresim/state/index';
import {toast} from 'react-toastify';
import PropTypes from 'prop-types';
import {initState, initVitals} from '../coresim/state/configuration';
import {initState as initDecisions} from '../coresim/state/team/decisions';
import ConfirmModal from '../components/ConfirmModal';
import Transition from '../components/ModalTransition';

const NextQuarter = (props) => {
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const [showNextQuarterConfirm, setShowNextQuarterConfirm] = useState(false);

  async function moveQuarter() {
    try {
      props.startOver();
      await API.put('state',
        `/simulations/${
          props.coresim.id
        }/tick/quarter/${props.quarter + 1}`
      );

      if (props.admin) {
        props.reloadAdmin()
      }
      toast.success('Successfully started next quarter.');
    } catch (e) {
      toast.error(e.toString());
    }
  }

  async function reset() {
    const updatedSim = Object.assign(props.coresim);

    const updatedTeams = updatedSim.teams;
    updatedTeams.map((team) => {
      team.configuration = initState;
      team.vitalsHistory = [initVitals];
      team.decisionHistory = [];
      team.decisions = initDecisions;
      return '';
    });

    const newSimulation = Object.assign(props.coresim);
    newSimulation.quarter.counter = 0;
    newSimulation.simStarted = false;
    newSimulation.completed = false;

    try {
      props.startOver();
      await API.put('mongo', `/sims/${props.coresim._id}`, {body: newSimulation});
      if (props.admin) {
        props.reloadAdmin()
      }
      toast.success('Successfully restarted sim');
    } catch (e) {
      toast.error(e.toString());
    }
  }

  const handleMoveQuarterClick = () => {
    if (props.admin) {
      setShowNextQuarterConfirm(true);
    } else {
      moveQuarter();
    }
  };

  const handleResetClick = () => {
    setShowResetConfirm(true);
  };

  const handleConfirmMoveQuarter = () => {
    setShowNextQuarterConfirm(false);
    moveQuarter();
  };

  const handleConfirmReset = () => {
    setShowResetConfirm(false);
    reset();
  };

  const handleCancelMoveQuarter = () => {
    setShowNextQuarterConfirm(false);
  };

  const handleCancelReset = () => {
    setShowResetConfirm(false);
  };

  const [exportName, exportUrl, exportFile] = useMemo( () => {
    let exportText = 'Pre-assign Room Name,Email Address\n';
    const teams = props.coresim.teams;

    for(const team of teams) {
      for(const member of team.members) {
        exportText += `${team.teamName},${member.email}\n`;
      }
    }

    const file = new Blob([exportText], {type: 'text/csv'});
    const url = URL.createObjectURL(file);
    const name = `${props.coresim.name}-zoom-export.csv`;

    return [name, url, file];
  }, [props.coresim]);

  const lastQuarter = props.coresim.quarter.counter > props.coresim.quarters.length - 1 ? true : false;

  return (
    <React.Fragment>
      <div>
        <Button disabled={lastQuarter} variant="contained" color="primary" onClick={handleMoveQuarterClick}>Next Quarter</Button>
        <Button style={{marginLeft: 20}} variant="contained" color="primary" href={exportUrl} download={exportName}>Zoom Export</Button>
        <Button  style={{marginLeft: 20, display: props.admin ? 'inline-block' : 'none'}} variant="contained" color="primary" onClick={handleResetClick}>Reset</Button>
      </div>
      <Dialog
        style={{
          margin: 'auto',
        }}
        open={showNextQuarterConfirm}
        TransitionComponent={Transition}
        keepMounted
        disableEscapeKeyDown={true}
        fullScreen={false}
        fullWidth={false}
        disableBackdropClick={true}
        hideBackdrop={false}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <ConfirmModal 
          handleConfirm={handleConfirmMoveQuarter} 
          handleCancel={handleCancelMoveQuarter} 
          message="Are you sure you want to move to the next quarter? This action cannot be undone."
          confirmType="advancement"/>
      </Dialog>
      <Dialog
        style={{
          margin: 'auto',
        }}
        open={showResetConfirm}
        TransitionComponent={Transition}
        keepMounted
        disableEscapeKeyDown={true}
        fullScreen={false}
        fullWidth={false}
        disableBackdropClick={true}
        hideBackdrop={false}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <ConfirmModal 
          handleConfirm={handleConfirmReset} 
          handleCancel={handleCancelReset} 
          message="Are you sure you want to reset the simulation? This will reset all teams, quarters, and decisions. This action cannot be undone."
          confirmType="reset"/>
      </Dialog>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    // quarter: state.coresim.quarter.counter,
    // coresim: state.coresim,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateQuarter: () => getTickAction(),
      startOver: (state) => startOver(state),
      getPreload: (data) => getPreload(data),
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NextQuarter);

NextQuarter.propTypes = {
  sim: PropTypes.object,
  updateQuarter: PropTypes.func,
  startOver: PropTypes.func,
  admin: PropTypes.bool,
  reloadAdmin: PropTypes.func,
  coresim: PropTypes.object,
  quarter: PropTypes.number
};
